/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetOffersForSpecificNewbuildingSearchSliderRequest,
  TGetOffersForSpecificNewbuildingSearchSliderModel,
  IMappers,
  TGetOffersForSpecificNewbuildingSearchSliderResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetOffersForSpecificNewbuildingSearchSliderResponse } from '../../entities/response/GetOffersForSpecificNewbuildingSearchSliderResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOffersForSpecificNewbuildingSearchSliderModel(
  parameters: TGetOffersForSpecificNewbuildingSearchSliderRequest,
): TGetOffersForSpecificNewbuildingSearchSliderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-content-promotion',
    pathApi: '/v1/get-offers-for-specific-newbuilding-search-slider/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetOffersForSpecificNewbuildingSearchSliderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetOffersForSpecificNewbuildingSearchSliderRequest;
}

export async function fetchGetOffersForSpecificNewbuildingSearchSlider<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOffersForSpecificNewbuildingSearchSliderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOffersForSpecificNewbuildingSearchSliderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOffersForSpecificNewbuildingSearchSliderModel(parameters),
    config,
  )) as FetchResponse<TGetOffersForSpecificNewbuildingSearchSliderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOffersForSpecificNewbuildingSearchSliderResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOffersForSpecificNewbuildingSearchSliderResponse>;
}
